import { z } from 'zod'
import { appConfig } from '@/config/app.ts'
import { branchOfficeSchema } from '@/core/types/BranchOffice'

export type NewBranchOfficeData = z.infer<typeof branchOfficeSchema>

export interface BranchOfficeState {
  isLoadingAllies: boolean
  isCreateBranchOfficeModalOpen: boolean
  isEditBranchOfficeModalOpen: boolean
  selectedBranchOfficeId: string | null
  branchOfficeFilters: string
  newBranchOfficeData: NewBranchOfficeData | null
}

export const initialState: BranchOfficeState = {
  isLoadingAllies: false,
  isCreateBranchOfficeModalOpen: false,
  isEditBranchOfficeModalOpen: false,
  selectedBranchOfficeId: null,
  branchOfficeFilters: `?limit=${appConfig.pagination.defaultValue}`,
  newBranchOfficeData: null
}
